module.exports = __webpack_public_path__ + "static/media/sort-numeric-up.64190829.svg";